module.exports = __webpack_public_path__ + "img/red_health_logo.7b2e7f3c.svg";